/**
 * 公告栏 的状态管理
 */
import { GET, URLS } from '../../utils'

export const types = {
  FETCH_BRAND_DATA: 'BRAND/FETCH_BRAND_DATA',
  LOAD_DATA: 'BRAND/LOAD_DATA'
}

const state = {
  data: []
}
const mutations = {
  [types.LOAD_DATA] (state, param) {
    state.data = param
  }
}
const actions = {
  [types.FETCH_BRAND_DATA] ({ dispatch, commit, state, rootState, rootGetter }) {
    // var arr = loadData();
    fetchBulletBrand((response) => {
      var arr = response.results
      commit(types.LOAD_DATA, arr)
    })
    // commit(types.LOAD_DATA, arr);
  }
}
const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}

const loadData = () => {
  var dic = {
    text: 'NOIP 竞赛名单公布'
  }
  var arr = []
  for (var i = 0; i < 10; i++) {
    arr.push(dic)
  }
  return arr
}

const fetchBulletBrand = (callback) => {
  GET(URLS.list_bullet_board).then(response => {
    if (callback) { callback(response) }
  })
}
